<template>
  <div class="w-100 h-100">
    <CRow>
      <CCol
        class="p-0 d-flex justify-content-center align-items-top"
        :md="showLegend ? 8 : 12"
      >
        <CChartPie
          ref="chartRef"
          :datasets="datasets"
          :labels="labels"
          :options="defaultOptions"
          :style="`
            height: ${height}px;
          `"
        />
      </CCol>
      <CCol class="p-0" lg="4" md="4" sm="12" v-if="showLegend">
        <div class="pie-legend">
          <div class="legend" v-for="legend in data" :key="legend.name">
            <p
              class="legend-count m-0"
              :style="`color: ${legend.backgroundColor}`"
            >
              {{ legend.value }}
            </p>
            <p class="label">{{ legend.name }}</p>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { CChartPie } from "@coreui/vue-chartjs";
import PieChartCustomLegend from "@/components/reusable/Charts/PieChartCustomLegend";

export default {
  name: "BasicPie",
  components: { CChartPie, PieChartCustomLegend },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: () => ({
        maintainAspectRatio: false,
        animation: {
          duration: 0, // Disable all animations
        },
        legend: {
          display: true,
        },
      }),
    },
    height: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    datasets() {
      const backgroundColor = this.data.map((val) => val.backgroundColor);
      const data = this.data.map((val) => val.value);
      return [
        {
          data: data,
          backgroundColor: backgroundColor,
          borderColor: this.data.map((val) => val.borderColor),
          borderWidth: 1,
        },
      ];
    },
    labels() {
      return this.data.map((val) => val.name);
    },
    defaultOptions() {
      const opt = this.options;
      opt.legend.display = this.showLegend;
      return opt;
    },
  },
};
</script>
<style lang="scss" scoped>
.pie-legend {
  display: flex;
  flex-flow: row wrap;
  .legend {
    width: 25%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 5px 0;
    .legend-count {
      font-weight: 600;
      font-size: 16px;
    }
    .label {
      margin: 0;
      // white-space: nowrap;
      font-size: 11px;
      word-break: break-word;
      text-align: center;
    }
  }
  @media only screen and (max-width: 320px) {
    .pie-legend {
      .legend {
        width: 33%;
      }
    }
  }
}
</style>
